export const Footer = {
  footer_copyright: "footer_copyright",
  footer_link_title1: "footer_link_title1",
  footer_link_title2: "footer_link_title2",
  footer_link_about: "footer_link_about",
  footer_link_services: "footer_link_services",
  footer_link_blog: "footer_link_blog",
  footer_link_policy: "footer_link_policy",
  footer_link_companies: "footer_link_companies",
  footer_link_faq: "footer_link_faq",
  footer_subscription_title: "footer_subscription_title",
  footer_subscription_input: "footer_subscription_input",
  footer_coded_by_me: "footer_coded_by_me"
};

export const SiteNav = {
  adressess: "adressess",
  cargos: "cargos",
  settings: "settings",
  track_cargo: "track_cargo",
  logout: "logout",
  search: "search",
  account: "account",
};

const FormControls = {
  smart_sorting: "smart_sorting",
  by_rating: "by_rating",
  by_price: "by_price",
  by_delivery_speed: "by_delivery_speed",
  oldest_comments:"oldest_comments",
  newest_comments:"newest_comments",
  all_comments:"all_comments"
};

const ProductCard = {
  day: "day",
  fast_delivery: "fast_delivery",
  highlights: "highlights",
  new_companies: "new_companies",
  product_card_delivery: "product_card_delivery",
  product_card_kg_price: "product_card_kg_price",
  product_card_minimum: "product_card_minimum",
};

const Info = {
  total_founded: "total_founded",
  cargo_companies: "cargo_companies",
  company: "company",
  comment: "comment",
  membership_date: "membership_date",
  cargo_price: "cargo_price",
  starting_price: "starting_price",
  about: "about",
  minimum_shipment_abbreviated: "minimum_shipment_abbreviated",
  tooltip_price_may_vary: "tooltip_price_may_vary",
};

const Comment = {
  company_response: "company_response",
  comments_loading: "comments_loading",
  add_comment: "add_comment",
  comment_question: "comment_question",
  share_your_opinion: "share_your_opinion",
  share: "share",
};

const Actions = {
  call_courier: "call_courier",
  accept_and_call_courier: "accept_and_call_courier",
  report_company: "report_company",
  go_to_homepage: "go_to_homepage",
  action_track_cargo: "action_track_cargo",
  action_update_info: "action_update_info",
  action_cancel: "action_cancel",
  action_add_new_address: "action_add_new_address",
  action_change: "action_change",
  action_change_password: "action_change_password",
  action_apply: "action_apply",
  action_save_address: "action_save_address",
  action_show_results: "action_show_results",
  action_comment: "action_comment",
  action_go_to_profile: "action_go_to_profile",
  action_show_all: "action_show_all",
};

const Paths = {
  home_page: "home_page",
  all_companies: "all_companies",
  path_call_courier: "path_call_courier",
};

const Form = {
  form_calling_courier_and_prica_calculator:
    "form_calling_courier_and_prica_calculator",
  form_shipper: "form_shipper",
  form_name_surname: "form_name_surname",
  form_tel: "form_tel",
  form_shipping_address: "form_shipping_address",
  form_address_details: "form_address_details",
  form_recipient: "form_recipient",
  form_warn_empty: "form_warn_empty",
  form_warn_email_invalid_format: "form_warn_email_invalid_format",
  form_warn_tel_invalid: "form_warn_tel_invalid",
  form_warn_password_unmatched: "form_warn_password_unmatched",
  form_delivery_address: "form_delivery_address",
  form_what_to_ship: "form_what_to_ship",
  form_what_to_ship_desc: "form_what_to_ship_desc",
  form_cargo_weight: "form_cargo_weight",
  form_box_weight: "form_box_weight",
  form_cargo_receival_date: "form_cargo_receival_date",
  form_date_select_today: "form_date_select_today",
  form_date_select_tomorrow: "form_date_select_tomorrow",
  form_date_custom: "form_date_custom",
  form_note: "form_note",
  form_note_optional: "form_note_optional",
  form_privacy_policy: "form_privacy_policy",
  form_country: "form_country",
  form_district: "form_district",
  form_error: "form_error",
  form_country_land: "form_country_land",
  form_do_you_have_coupon: "form_do_you_have_coupon",
  form_enter_coupon_code: "form_enter_coupon_code",
};

const TotalCard = {
  total_card_title: "total_card_title",
  total_card_shipper: "total_card_shipper",
  total_card_recipient: "total_card_recipient",
  total_card_cargo_route: "total_card_cargo_route",
  total_shipment_weight: "total_shipment_weight",
  total_price_title: "total_price_title",
  total_cargo_price: "total_cargo_price",
  total_service_price: "total_service_price",
  total_free: "total_free",
  total_sum: "total_sum",
  total_coupon_discount: "total_coupon_discount",
};

const Modal = {
  member_login: "member_login",
  modal_new_membership: "modal_new_membership",
  password_proccess: "password_proccess",
  modal_tel: "modal_tel",
  forgot_password: "forgot_password",
  login: "login",
  password: "password",
  login_via_social: "login_via_social",
  no_account_question: "no_account_question",
  have_account_question: "have_account_question",
  modal_sign_up: "modal_sign_up",
  remember_me: "remember_me",
  password_again: "password_again",
  renew_password: "renew_password",
  sms_verification: "sms_verification",
  accept_and_continue: "accept_and_continue",
  send_code_again: "send_code_again",
  enter_4_digit_number: "enter_4_digit_number",
  modal_register: "modal_register",
  modal_enter_tel_text: "modal_enter_tel_text",
  modal_cargo_track: "modal_cargo_track",
  modal_enter_track_number: "modal_enter_track_number",
  track_no: "track_no",
};

const InfoPages = {
  info_thanks: "info_thanks",
  info_no_order_created: "info_no_order_created",
  info_shipping_process: "info_shipping_process",
  info_from_page_follow: "info_from_page_follow",
  info_track_number: "info_track_number",
  info_profile: "info_profile",
};


const ProfilePage = {
  profile_notifications: "profile_notifications",
  profile_cargo_situation_onway: "profile_cargo_situation_onway",
  profile_cargo_situation_delivered: "profile_cargo_situation_delivered",
  profile_enter_track_number: "profile_enter_track_number",
  profile_cargo_status_title: "profile_cargo_status_title",
  profile_cargo_situation: "profile_cargo_situation",
  profile_track_no: "profile_track_no",
  profile_cargo_from: "profile_cargo_from",
  profile_cargo_to: "profile_cargo_to",
  profile_cargo_date: "profile_cargo_date",
  profile_price: "profile_price",
  profile_all_cargos: "profile_all_cargos",
  profile_on_the_way: "profile_on_the_way",
  profile_completed: "profile_completed",
  profile_all: "profile_all",
  profile_cargo_id: "profile_cargo_id",
};

const Settings = {
  settings_support_text: "settings_support_text",
  settings_title: "settings_title",
  settings_write_message: "settings_write_message",
  settings_current_password: "settings_current_password",
  settings_new_password: "settings_new_password",
  settings_new_password_again: "settings_new_password_again",
};

const Header = {
  header_search: "header_search",
  header_btn: "header_btn",
  current_language: "current_language",
};

const MyAdresses = {
  my_addresses_title: "my_addresses_title",
  address: "address",
};

const AddAddress = {
  add_address_name: "add_address_name",
  add_address_city: "add_address_city",
  add_address_district: "add_address_district",
  add_address_details: "add_address_details",
};

const NotFound = {
  not_found_title: "not_found_title",
  not_found_text: "not_found_text",
};

const CargoTrack = {
  cargo_track_title: "cargo_track_title",
  cargo_track_cargo_accepted: "cargo_track_cargo_accepted",
  cargo_track_shipped: "cargo_track_shipped",
  cargo_track_arrived: "cargo_track_arrived",
  cargo_track_at_branch: "cargo_track_at_branch",
  cargo_track_out_for_distribution: "cargo_track_out_for_distribution",
  cargo_track_delivered: "cargo_track_delivered",
  cargo_track_last_update: "cargo_track_last_update",
  cargo_track_no: "cargo_track_no",
  cargo_track_tel: "cargo_track_tel",
  cargo_track_sum: "cargo_track_sum",
};

const FAQ = {
  faq_search_title: "faq_search_title",
  faq_search_text: "faq_search_text",
  faq_search_placeholder: "faq_search_placeholder",
  faq_support_link: "faq_support_link",
  faq_text_part1: "faq_text_part1",
  faq_text_part2: "faq_text_part2",
  faq_title: "faq_title",
  faq_tab1: "faq_tab1",
  faq_tab2: "faq_tab2",
  faq_tab3: "faq_tab3",
};

const CompanyCard = {
  company_card_free_packaging: "company_card_free_packaging",
};

const Toast = {
  toast_success_title: "toast_success_title",
  toast_error_title: "toast_error_title",
  toast_warn_title: "toast_warn_title",
  toast_info_title: "toast_info_title",
  toast_success_text: "toast_success_text",
  toast_error_text: "toast_error_text",
  toast_warn_text: "toast_warn_text",
  toast_info_text: "toast_info_text",
};

const Extra = {
  blog_similar_blogs:"blog_similar_blogs"
}

const Shared = {
  ...Footer,
  ...SiteNav,
  ...FormControls,
  ...ProductCard,
  ...Info,
  ...Paths,
  ...Comment,
  ...Actions,
  ...TotalCard,
  ...Form,
  ...Modal,
  ...InfoPages,
  ...ProfilePage,
  ...Settings,
  ...MyAdresses,
  ...AddAddress,
  ...Header,
  ...NotFound,
  ...CargoTrack,
  ...FAQ,
  ...CompanyCard,
  ...Toast,
  ...Extra
};

export default Shared;
